// extracted by mini-css-extract-plugin
module.exports = {"editorBlockTitle":"_3iaSRX","root":"_2mWqeo","bordered":"_1MgIes","padded":"_3v1CEO","colored":"TpG2az","fullWidth":"EGHBdS"};